import { Component, input } from '@angular/core';
import { UwProgress } from '../../ui/progress/uw-progress';
import type { RiskFactor } from '../../../core/models/risk.model';

@Component({
  selector: 'uw-risk-factor',
  standalone: true,
  imports: [UwProgress],
  template: `
    @if (factor(); as f) {
      <div>
        <div class="mb-1 flex items-center justify-between text-[11.5px]">
          <span class="font-medium text-secondary">{{ f.label }}</span>
          <span class="typo-mono font-semibold" [class]="toneClass(f.tone)">{{ f.score }}</span>
        </div>
        <uw-progress [value]="f.score" [tone]="f.tone" [label]="f.label" />
      </div>
    }
  `,
})
export class UwRiskFactor {
  readonly factor = input<RiskFactor | null>(null);

  protected toneClass(tone: string): string {
    const tones: Record<string, string> = {
      success: 'text-success',
      warning: 'text-warning',
      danger: 'text-danger',
      info: 'text-info',
    };
    return tones[tone] ?? 'text-secondary';
  }
}
